import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CheckIcon, XIcon } from 'lucide-react';
export function Pricing() {
  return <div className="w-full min-h-screen bg-[#1E2A38] text-[#F5F7FA] font-sans" data-id="element-2959">
      <Header data-id="element-2960" />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-2961">
        <div className="text-center mb-16" data-id="element-2962">
          <h1 className="text-4xl md:text-6xl font-bold mb-6" data-id="element-2963">
            Simple, Transparent Pricing
          </h1>
          <p className="text-lg md:text-xl text-[#F5F7FA] text-opacity-80 max-w-2xl mx-auto" data-id="element-2964">
            Choose the plan that's right for you and start preparing for
            meetings like never before.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-2965">
          {/* Free Tier */}
          <div className="bg-[#F5F7FA] bg-opacity-5 rounded-xl overflow-hidden border border-[#F5F7FA] border-opacity-10 flex flex-col" data-id="element-2966">
            <div className="p-6 border-b border-[#F5F7FA] border-opacity-10" data-id="element-2967">
              <h3 className="text-xl font-semibold mb-2" data-id="element-2968">Free</h3>
              <p className="text-[#F5F7FA] text-opacity-70 mb-4" data-id="element-2969">
                For individuals testing it
              </p>
              <div className="flex items-baseline" data-id="element-2970">
                <span className="text-4xl font-bold" data-id="element-2971">$0</span>
                <span className="ml-1 text-[#F5F7FA] text-opacity-70" data-id="element-2972">
                  /month
                </span>
              </div>
            </div>
            <div className="p-6 flex-grow" data-id="element-2973">
              <ul className="space-y-4" data-id="element-2974">
                <li className="flex items-start" data-id="element-2975">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-2976" />
                  <span data-id="element-2977">Limited meetings/month (5)</span>
                </li>
                <li className="flex items-start" data-id="element-2978">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-2979" />
                  <span data-id="element-2980">Basic calendar sync</span>
                </li>
                <li className="flex items-start" data-id="element-2981">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-2982" />
                  <span data-id="element-2983">Basic AI summaries</span>
                </li>
                <li className="flex items-start" data-id="element-2984">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-2985" />
                  <span data-id="element-2986">Manual attendee data only</span>
                </li>
              </ul>
            </div>
            <div className="p-6 border-t border-[#F5F7FA] border-opacity-10" data-id="element-2987">
              <button className="w-full py-2 px-4 bg-[#F5F7FA] bg-opacity-10 hover:bg-opacity-20 rounded-lg text-[#F5F7FA] font-medium transition-colors" data-id="element-2988">
                Get Started
              </button>
            </div>
          </div>
          {/* Standard Tier */}
          <div className="bg-[#F5F7FA] bg-opacity-5 rounded-xl overflow-hidden border border-[#C8F169] border-opacity-30 flex flex-col relative" data-id="element-2989">
            <div className="absolute top-0 right-0 bg-[#C8F169] text-[#1E2A38] px-4 py-1 text-sm font-medium" data-id="element-2990">
              Popular
            </div>
            <div className="p-6 border-b border-[#F5F7FA] border-opacity-10" data-id="element-2991">
              <h3 className="text-xl font-semibold mb-2" data-id="element-2992">Standard</h3>
              <p className="text-[#F5F7FA] text-opacity-70 mb-4" data-id="element-2993">
                For professionals
              </p>
              <div className="flex items-baseline" data-id="element-2994">
                <span className="text-4xl font-bold" data-id="element-2995">$13</span>
                <span className="ml-1 text-[#F5F7FA] text-opacity-70" data-id="element-2996">
                  /month
                </span>
              </div>
            </div>
            <div className="p-6 flex-grow" data-id="element-2997">
              <ul className="space-y-4" data-id="element-2998">
                <li className="flex items-start" data-id="element-2999">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-3000" />
                  <span data-id="element-3001">Weekly calendar scan</span>
                </li>
                <li className="flex items-start" data-id="element-3002">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-3003" />
                  <span data-id="element-3004">Manual brief requests (up to 15 per week)</span>
                </li>
                <li className="flex items-start" data-id="element-3005">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-3006" />
                  <span data-id="element-3007">Summarization of attendees, company</span>
                </li>
                <li className="flex items-start" data-id="element-3008">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-3009" />
                  <span data-id="element-3010">Connection to Inbox for previous conversations</span>
                </li>
              </ul>
            </div>
            <div className="p-6 border-t border-[#F5F7FA] border-opacity-10" data-id="element-3011">
              <button className="w-full py-2 px-4 bg-[#C8F169] hover:bg-opacity-90 rounded-lg text-[#1E2A38] font-medium transition-colors" data-id="element-3012">
                Subscribe Now
              </button>
            </div>
          </div>
          {/* Professional Tier */}
          <div className="bg-[#F5F7FA] bg-opacity-5 rounded-xl overflow-hidden border border-[#F5F7FA] border-opacity-10 flex flex-col" data-id="element-3013">
            <div className="p-6 border-b border-[#F5F7FA] border-opacity-10" data-id="element-3014">
              <h3 className="text-xl font-semibold mb-2" data-id="element-3015">Professional</h3>
              <p className="text-[#F5F7FA] text-opacity-70 mb-4" data-id="element-3016">
                For power users
              </p>
              <div className="flex items-baseline" data-id="element-3017">
                <span className="text-4xl font-bold" data-id="element-3018">$29</span>
                <span className="ml-1 text-[#F5F7FA] text-opacity-70" data-id="element-3019">
                  /month
                </span>
              </div>
            </div>
            <div className="p-6 flex-grow" data-id="element-3020">
              <p className="text-sm text-[#F5F7FA] text-opacity-70 mb-4" data-id="element-3021">
                Everything in Standard, plus:
              </p>
              <ul className="space-y-4" data-id="element-3022">
                <li className="flex items-start" data-id="element-3023">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-3024" />
                  <span data-id="element-3025">Integrations to CRM</span>
                </li>
                <li className="flex items-start" data-id="element-3026">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-3027" />
                  <span data-id="element-3028">Other 3rd party integrations</span>
                </li>
                <li className="flex items-start" data-id="element-3029">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-3030" />
                  <span data-id="element-3031">Unlimited meeting briefs</span>
                </li>
                <li className="flex items-start" data-id="element-3032">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-3033" />
                  <span data-id="element-3034">Advanced AI insights</span>
                </li>
              </ul>
            </div>
            <div className="p-6 border-t border-[#F5F7FA] border-opacity-10" data-id="element-3035">
              <button className="w-full py-2 px-4 bg-[#F5F7FA] bg-opacity-10 hover:bg-opacity-20 rounded-lg text-[#F5F7FA] font-medium transition-colors" data-id="element-3036">
                Subscribe Now
              </button>
            </div>
          </div>
          {/* Business/Enterprise Tier */}
          <div className="bg-[#F5F7FA] bg-opacity-5 rounded-xl overflow-hidden border border-[#F5F7FA] border-opacity-10 flex flex-col" data-id="element-3037">
            <div className="p-6 border-b border-[#F5F7FA] border-opacity-10" data-id="element-3038">
              <h3 className="text-xl font-semibold mb-2" data-id="element-3039">Enterprise</h3>
              <p className="text-[#F5F7FA] text-opacity-70 mb-4" data-id="element-3040">
                For organizations
              </p>
              <div className="flex items-baseline" data-id="element-3041">
                <span className="text-xl font-bold" data-id="element-3042">Custom Pricing</span>
              </div>
            </div>
            <div className="p-6 flex-grow" data-id="element-3043">
              <p className="text-sm text-[#F5F7FA] text-opacity-70 mb-4" data-id="element-3044">
                Everything in Professional, plus:
              </p>
              <ul className="space-y-4" data-id="element-3045">
                <li className="flex items-start" data-id="element-3046">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-3047" />
                  <span data-id="element-3048">Dedicated onboarding</span>
                </li>
                <li className="flex items-start" data-id="element-3049">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-3050" />
                  <span data-id="element-3051">Admin console</span>
                </li>
                <li className="flex items-start" data-id="element-3052">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-3053" />
                  <span data-id="element-3054">Custom integrations</span>
                </li>
                <li className="flex items-start" data-id="element-3055">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-3056" />
                  <span data-id="element-3057">SOC 2 / SSO</span>
                </li>
                <li className="flex items-start" data-id="element-3058">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-3059" />
                  <span data-id="element-3060">API access</span>
                </li>
                <li className="flex items-start" data-id="element-3061">
                  <CheckIcon className="h-5 w-5 text-[#C8F169] mr-2 mt-0.5" data-id="element-3062" />
                  <span data-id="element-3063">Support SLAs</span>
                </li>
              </ul>
            </div>
            <div className="p-6 border-t border-[#F5F7FA] border-opacity-10" data-id="element-3064">
              <button className="w-full py-2 px-4 bg-[#F5F7FA] bg-opacity-10 hover:bg-opacity-20 rounded-lg text-[#F5F7FA] font-medium transition-colors" data-id="element-3065">
                Contact Sales
              </button>
            </div>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-3066">
          <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-3067">
            Need a custom solution?
          </h2>
          <p className="text-lg text-[#F5F7FA] text-opacity-80 max-w-2xl mx-auto mb-8" data-id="element-3068">
            Our team can help create a tailored plan that meets your specific
            requirements.
          </p>
          <button className="py-3 px-6 bg-[#C8F169] hover:bg-opacity-90 rounded-lg text-[#1E2A38] font-medium transition-colors" data-id="element-3069">
            Contact Our Sales Team
          </button>
        </div>
      </main>
      <Footer data-id="element-3070" />
    </div>;
}